import { useStore } from '@nanostores/react';
import { OpenAPI } from '../../api/core/OpenAPI';
import { request as __request } from '../../api/core/request';

export const AircallOAuthRedirectHandler = () => {
  const org = useStore($org);
  const effectRunRef = useRef(false);

  const [message, setMessage] = useState(
    'Processing Aircall Authentication...',
  );

  useEffect(() => {
    if (!org || effectRunRef.current) return; // Prevent running the effect again
    effectRunRef.current = true;
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const redirectUri = `${window.location.origin}/aircall_oauth_redirect`; // Your actual redirect URI
      if (!code) {
        console.error('Invalid state or missing code/state');
        return;
      }

      const body: {
        Code: string;
        RedirectURI: string;
        OrgId?: string;
      } = {
        Code: code,
        RedirectURI: redirectUri,
      };

      if (org) {
        body.OrgId = org.id;
      }

      try {
        await __request(OpenAPI, {
          method: 'POST',
          url: `/integrations/aircall/getAccessToken`,
          body,
          mediaType: 'application/json',
        });

        setMessage('Authentication successful, redirecting to integrations...');
        window.location.href = `/settings?activeNav=integrations`;
      } catch (error) {
        setMessage('Authentication unsuccessful, please try again!');
        window.location.href = `/settings?activeNav=integrations`;
        console.error('Error during authentication callback', error);
      }
    };

    handleCallback();
  }, [org]);

  return (
    <div>
      <p>{message}</p>
    </div>
  );
};
